{
  "title": "Alatan",
  "intro": "Lukis kawasan untuk mendapatkan imej atau menganalisisnya. Tiada apa-apa disimpan melainkan anda mencipta projek.",
  "dock": {
    "label": "Alatan kanvas",
    "projects": "Projek",
    "areas": "Kawasan",
    "upload": "Muat naik kawasan",
    "draw": "Lukis kawasan",
    "measure": "Ukur",
    "basemap": "Peta asas"
  },
  "hint": {
    "select": "Lukis atau muat naik kawasan untuk bermula.",
    "selectHasAreas": "Klik kawasan untuk memilih tindakan.",
    "polygon": "Klik untuk meletakkan bucu. Klik dua kali untuk selesai.",
    "measure": "Klik untuk mengukur jarak. Klik dua kali untuk selesai."
  },
  "area": {
    "defaultName": "Kawasan · {{when}}",
    "saving": "Menyimpan kawasan…",
    "refused": "Kawasan itu tidak boleh digunakan: {{reason}}",
    "failed": "Kawasan tidak dapat disimpan. Cuba lagi.",
    "hectares": "{{area}} ha"
  },
  "actions": {
    "title": "Pilih proses:",
    "label": "Tindakan kawasan",
    "image": "Imej",
    "analyse": "Analisis",
    "simulate": "Prompt",
    "soon": "Akan datang",
    "delete": "Padam kawasan",
    "createProject": "Cipta projek"
  },
  "panel": {
    "close": "Tutup",
    "image": "Imej satelit",
    "analyse": "Analisis",
    "upload": "Muat naik kawasan",
    "areas": "Kawasan di kanvas ini"
  },
  "areas": {
    "none": "Belum ada kawasan. Lukis atau muat naik satu.",
    "session": "Kawasan hanya kekal selagi halaman ini dibuka. Cipta projek untuk menyimpannya.",
    "zoom": "Zum ke {{name}}"
  },
  "analyse": {
    "capture": "Imej",
    "noCaptures": "Dapatkan imej dahulu. Analisis dijalankan pada imej yang diperoleh untuk kawasan ini.",
    "getImagery": "Dapatkan imej",
    "analytics": "Apa yang hendak diukur",
    "all": "Semua",
    "run": "Jalankan analisis",
    "done": "Analisis selesai. Litupan tanah dipaparkan di peta.",
    "downloads": "Muat turun",
    "report": "Buka laporan penuh",
    "show": "Papar di peta",
    "hide": "Sembunyikan dari peta"
  },
  "create": {
    "keeps": "Kawasan, imej dan analisisnya dipindahkan ke projek seperti sedia ada."
  },
  "leave": {
    "title": "Tinggalkan kanvas?",
    "body": "Kawasan yang bukan projek akan dikosongkan apabila anda keluar. Muat turun apa yang diperlukan, atau cipta projek untuk menyimpannya.",
    "stay": "Kekal",
    "go": "Keluar"
  },
  "tips": {
    "dock": {
      "projects": "Pergi ke projek anda. Kawasan yang belum dijadikan projek hanya kekal di sini sehingga anda keluar.",
      "draw": "Lukis kawasan di peta: klik untuk meletakkan setiap bucu, klik dua kali untuk selesai.",
      "areas": "Senaraikan kawasan di kanvas ini dan zum ke salah satunya.",
      "measure": "Ukur jarak di peta. Ukuran tidak disimpan.",
      "upload": "Tambah kawasan daripada fail: GeoJSON, KML atau Shapefile dalam zip, sehingga 5 MB."
    },
    "actions": {
      "image": "Cari imej satelit kawasan ini mengikut tarikh, dapatkan imej, bandingkan dua, atau muat turun sebagai GeoTIFF.",
      "analyse": "Petakan litupan tanah, bangunan, kawasan hijau dan air, serta jalan daripada imej kawasan ini.",
      "simulate": "Terangkan rancangan untuk kawasan ini dengan kata-kata anda sendiri dan lihat pilihan untuknya. Akan datang.",
      "delete": "Buang kawasan ini dan semua yang dihasilkan untuknya dari kanvas.",
      "createProject": "Simpan kawasan ini: ia menjadi projek, bersama imej dan analisisnya."
    },
    "basemap": "Tukar peta di bawah: imej satelit, jalan, atau kosong."
  },
  "image": {
    "provider": "Penyedia",
    "from": "Tarikh mula",
    "to": "Tarikh tamat",
    "search": "Cari",
    "ask": "Pilih penyedia dan tarikh dalam kad Imej kawasan.",
    "summary": "{{provider}} · {{from}} hingga {{to}}",
    "captured": "Ditangkap",
    "preset": {
      "week": "Minggu ini",
      "month": "Bulan ini",
      "year": "Tahun ini",
      "2y": "2 tahun lalu",
      "5y": "5 tahun lalu",
      "all": "Semua",
      "custom": "Julat tersuai"
    },
    "short": {
      "esri": "Esri",
      "google": "Google",
      "sentinel-2": "Sentinel-2",
      "landsat": "Landsat"
    }
  }
}
